module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ManageCertificates', {
    attrs: {
      "Certificateparams": "{'organizationid':0,'Role':''}"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561bc861"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administration/Certificates.vue
// module id = 814
// module chunks = 1